import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowButton from '../../../../../../components/arrow-button';
import { DialogConfirmation } from '../../../../../../components/dialog/confirmation';
import TextInfo from '../../../../../../components/text-info';

type VersionDeviceButtonComponentProps = {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  deviceVersion: string;
  getCurrentDeviceVersion: () => Promise<void>;
};

export const VersionDeviceButtonComponent: React.FC<VersionDeviceButtonComponentProps> = ({
  show,
  deviceVersion,
  setShow,
  getCurrentDeviceVersion,
}) => {
  const { t } = useTranslation('device-info');
  const { t: tc } = useTranslation('common');

  return (
    <>
      <ArrowButton
        className="m-b-24"
        title={t('exalus.params.Version.currentVersion')}
        onClick={getCurrentDeviceVersion}
      />
      <DialogConfirmation
        show={show}
        setShow={setShow}
        header={t('exalus.params.Version.software')}
        primaryBtnText={`${tc('buttons.understand')}`}
        primaryBtnAction={() => setShow(false)}
      >
        <div className="version-value">
          <TextInfo
            value={deviceVersion}
            label={`${t('exalus.params.Version.currentVersion')}:`}
            big
            reverse
            className="m-b-8"
          />
        </div>
      </DialogConfirmation>
    </>
  );
};
